/**
 * Fetches the app registry from GET /api/apps/ on nexus-core.
 *
 * Returns only the apps the current user's groups permit (filtering
 * happens server-side in core.portal_apps + core.portal_app_groups).
 * Each row carries the iframe_url the IframeView should load.
 */

import { useApi } from "./useApi";

export function useApps() {
  return useApi("/api/apps/");
}
